import PassDates from '../../../Shared/Components/CampaignInvite/PassDates';
import PassDescription from '../../../Shared/Components/CampaignInvite/PassDescription';
import PassInvitees from '../../../Shared/Components/CampaignInvite/PassInvitees';
import ProjectEngagement
	from '../../../Shared/Components/CampaignInvite/ProjectEngagement';
import DashboardInvites from './DashboardInvites';
import DashboardStats from './DashboardStats';
import Greeting from './Greeting';
import VenueInfo from './VenueInfo';
import Welcome from './Welcome';

window.Vue.component('MerchantDashboardInvites', DashboardInvites);
window.Vue.component('MerchantDashboardStats', DashboardStats);
window.Vue.component('MerchantGreeting', Greeting);
window.Vue.component('MerchantPassDates', PassDates);
window.Vue.component('MerchantPassDescription', PassDescription);
window.Vue.component('MerchantPassInvitees', PassInvitees);
window.Vue.component('MerchantProjectEngagement', ProjectEngagement);
window.Vue.component('MerchantVenueInfo', VenueInfo);
window.Vue.component('MerchantWelcome', Welcome);
